
import {Types} from "./Field"

const CorrespondanceTypeDropDown = (type: string): Types | undefined => {
    switch (type) {
      case "string":
        return { name: "Chaine de caractère", type: "string" };
      case "int":
        return { name: "Nombre entier (int)", type: "int" };        
      case "long":
        return { name: "Nombre entier (long)", type: "long" };
      case "boolean":
        return { name: "Booléen", type: "boolean" };
      case "bytes":
        return { name: "Octets", type: "bytes" };
      case "float":
        return { name: "Nombre décimal (float)", type: "float" };         
      case "double":
        return { name: "Nombre décimal (double)", type: "double" };
      case "":
        return { name: "",  type:"" };
      default:
        return { name: "Complexe", type: "complex" };
    }
  };

  export default CorrespondanceTypeDropDown